import React from 'react'

import { useGetKeyPairValue, MILKvKeys } from 'api/microlearning/useAPIKeyValue'

export const useFeatureFlagHook = (): {
  status: string
  features: any
  getFeatureByKey: (key: string) => boolean
} => {
  const { status, data } = useGetKeyPairValue(MILKvKeys.FeatureFlag)

  const getFeatureByKey = React.useCallback(
    (key: string) => {
      if (status === 'loading') return false

      const featureList = data?.data || {}

      return (featureList && featureList[key]) || false
    },
    [data?.data, status]
  )

  return {
    status: status,
    features: data?.data,
    getFeatureByKey,
  }
}
